import { useState, useEffect, useRef, useContext, useMemo } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import { Link, useNavigate } from "react-router-dom";
import api from "../../../utils/api";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CartContext } from "../../contexts/cartContext";
import ToastNote from "../../golbal/notifications/toastNote";
// import Tooltip1 from "../../golbal/tooltip/tooltip";
import { CircularProgress } from "@mui/material";
import FormikErrRender from "../../persian/common/alerts/formikErrRender";
import addErrClass from "../../persian/common/alerts/addErrClass";
import tools from "../../../utils/tools";

export default function Login() {
  const { signedUser, user } = useContext(CartContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState({ passRec: false });
  const [showPassword, setShowPassword] = useState({
    password: false,
    rPass: false,
  });
  const messageRef = useRef(null);
  const returnUrl = window.location.origin + window.location.pathname;


  const googleHandle = async () => {
    console.log("returnUrl", returnUrl);
    const state = encodeURIComponent(
      JSON.stringify({
        returnUrl,
        affiliate: registerFormik.values.affiliate,
      })
    );
    // const url = `http://localhost:5000/api/auth/google?state=${state}`;
    const url = `https://metamarce.com/api/auth/google?state=${state}`;
    window.open(url, "_self");
  };
  const faceBookHandle = async () => {
    const state = encodeURIComponent(
      JSON.stringify({
        returnUrl,
        affiliate: registerFormik.values.affiliate,
      })
    );
    window.open(
      `https://metamarce.com/api/auth/facebook?state=${state}`,
      "_self"
    );
  };
  const twitterHandle = async () => {
    const state = encodeURIComponent(
      JSON.stringify({
        returnUrl,
        affiliate: registerFormik.values.affiliate,
      })
    );
    window.open(
      `http://localhost:5000/api/auth/twitter?state=${state}`,
      "_self"
    );
  };
  const githubHandle = async () => {
    const state = encodeURIComponent(
      JSON.stringify({
        returnUrl,
        affiliate: registerFormik.values.affiliate,
      })
    );
    window.open(
      `https://metamarce.com/api/auth/github?state=${state}`,
      "_self"
    );
  };

  function getAffData(key) {
    const urlParams = new URLSearchParams(window.location.search);
    const affiliateCode = urlParams.get("aff");
    if (affiliateCode?.length >= 10) {
      const ttl = 7 * 24 * 60 * 60 * 1000;
      const now = new Date();
      const item = {
        affCode: affiliateCode,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem("affiliate", JSON.stringify(item));
      return affiliateCode;
    }

    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    const affData = JSON.parse(itemStr);
    const now = new Date();

    // Compare the expiry time of the affData with the current time
    if (now.getTime() > affData.expiry) {
      // If the affData is expired, remove it from storage and return null
      localStorage.removeItem(key);
      return null;
    }
    console.log("getAffData(affiliate)", affData.affCode);
    return affData.affCode;
  }

  useEffect(() => {
    getSignedUser();
    // affiliateSet()
  }, []);

  async function getSignedUser() {
    if (user?.roles?.inclues(9999)) return;
    // console.log("getSignedUser");
    const response = await api.getUser();
    if (response?.error) return;
    signedUser(response.data);
    console.log("response.data", response.data);
    if (response.data.affiliateInfo.affiliatedby.length >= 10) {
      localStorage.removeItem("affiliate");
    }
  }

  // const lowercaseRegex = /(?=.*[a-z])/;
  // const uppercaseRegex = /(?=.*[A-Z])/;
  const numericRegex = /(?=.*[0-9])/;
  // const specialcharRegex = /(?=.*[$&+,:;=?@#|'<>.^*()%!-])/;
  // const combinedRegex = /^(?=.*[A-Za-z])[A-Za-z0-9#]+$/;
  const combinedRegex = /^[A-Za-z0-9# $&+,:;=?@|'<>.^*()%!-]+$/;

  const loginFormik = useFormik({
    initialValues: {
      email: "",
      phoneNumber: "",
      password: "",
      type: "email",
    },
    onSubmit: async (values) => {
      // console.log(values);
      values.phoneNumber = tools.prepareForSMS(values.phoneNumber);
      const currentTarget = document.querySelector("#loginBtn");
      currentTarget.setAttribute("disabled", true);
      setLoading((pre) => ({ ...pre, login: true }));
      const response = await api.login({
        email: values.email,
        phoneNumber: values.phoneNumber,
        password: values.password,
        type: values.type,
      });
      setLoading((pre) => ({ ...pre, login: false }));
      setTimeout(() => currentTarget.removeAttribute("disabled"), 8000);
      if (response.error)
        return messageRef.current.showError({
          message: (
            <div>
              <div> مشکل در انجام عملیات !</div>
              <div dir="ltr">{response.error}</div>
            </div>
          ),
        });

      // console.log(document.querySelector('.modal').modal('hide'));
      document.querySelector("#CloseLoging").click();

      // document.querySelector("body").classList.remove("modal-open");
      // document.querySelector(".modal-backdrop").remove();
      // document.body.style.overflow = "scroll";
      signedUser(response.data);
      if (response.data?.affiliateInfo?.affiliatedby?.length >= 10) {
        localStorage.removeItem("affiliate");
      }
    },
    validationSchema: Yup.object({
      // email: Yup.string()
      //   .email(" ایمیل خود را به درستی وارد کنید.")
      //   .required("2 ایمیل خود را وارد کنید")
      //   .trim()
      //   .lowercase(),
      // password : Yup.string().min(8 , 'پسورد حداقل باید 8 حرف باشد')

      email: Yup.string()
        .trim()
        .lowercase()
        .when("type", (type, schema, value) => {
          return type !== "email"
            ? schema.notRequired()
            : schema
                .required("ایمیل را وارد کنید.")
                .email("ایمیل را به درستی وارد کتید.");
        }),

      phoneNumber: Yup.string()
        .when("type", (type, schema, value) => {
          return type !== "phoneNumber"
            ? schema.notRequired()
            : schema
                .required("شماره تلفن فراموش نشه!")
                .test(
                  "is-valid-phone",
                  "شماره تلفن را با + و کد کشور(مثال: 6543 987 514 1+) شروع کنید!",
                  (value) => {
                    return isValidPhoneNumber(value || "");
                  }
                );
        })
        .trim(),
      password: Yup.string()
        .required("کلمه عبور را وارد کنید.")
        .matches(combinedRegex, "از حروف انگلیسی استفاده کنید")
        .min(8, "کلمه عبور حداقل باید ۸ حرف  داشته باشد."),
    }),
  });
  // console.log("loginFormik",loginFormik);
  const passRecoverFormik = useFormik({
    initialValues: {
      lcs: window.lcs,
      email: "",
      phoneNumber: "",
      type: "email",
    },
    onSubmit: async (values) => {
      console.log(values);
      values.phoneNumber = tools.prepareForSMS(values.phoneNumber);
      const el = document.querySelector("#passRecoverBtn");
      el.setAttribute("disabled", true);
      setLoading((pre) => ({ ...pre, passRec: true }));
      const response = await api.passRecover({ values, lcs: window.lcs });
      setLoading((pre) => ({ ...pre, passRec: false }));
      setTimeout(() => el.removeAttribute("disabled"), 1000 * 60);

      if (response.error)
        return messageRef.current.showError({
          message: (
            <div>
              <div> مشکل در انجام عملیات !</div>
              <div>{response.error}</div>
            </div>
          ),
        });
      const type = values.type === "phoneNumber" ? "شماره" : "ایمیل";
      return messageRef.current.showSuccess({
        message: `لینک بازیابی پسورد به ${type} زیر فرستاده شد.`,
      });
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim()
        .lowercase()
        .when("type", (type, schema, value) => {
          return type !== "email"
            ? schema.notRequired()
            : schema
                .required("ایمیل را وارد کنید.")
                .email("ایمیل را به درستی وارد کنید.");
        }),

      phoneNumber: Yup.string()
        .when("type", (type, schema, value) => {
          return type !== "phoneNumber"
            ? schema.notRequired()
            : schema
                .required("شماره تلفن فراموش نشه!")
                .test("is-valid-phone", "شماره تلفن نامعتر!", (value) => {
                  return isValidPhoneNumber(value || "");
                });
        })
        .trim(),
    }),
  });
  // function affiliateSet(){
  //   const urlParams  = new URLSearchParams(window.location.search)
  //   const affiliateCode = urlParams.get("aff")
  //   console.log('affiliateCode',affiliateCode)
  //   if(affiliateCode?.length>=10){
  //     localStorage.setItem("affiliate",affiliateCode)
  //     registerFormik.setFieldValue("affiliate",affiliateCode)
  //     return affiliateCode}
  //   const storedAffiliate = localStorage.getItem("affiliate")
  //   if(storedAffiliate?.length>=10){
  //     registerFormik.setFieldValue("affiliate",storedAffiliate)
  //     return storedAffiliate}
  // }

  const registerFormik = useFormik({
    initialValues: {
      lcs: window.lcs,
      // affiliate: affCode,
      affiliate: getAffData("affiliate"),
      userName: "",
      emailRegister: "",
      phoneNumber: "",
      passwordRegister: "",
      confirmPassword: "",
      type: "emailRegister",
      terms: true,
    },
    onSubmit: async (values) => {      
      values.phoneNumber = tools.prepareForSMS(values.phoneNumber);
      const el = document.querySelector("#registerBtn");
      el.setAttribute("disabled", true);
      setLoading((pre) => ({ ...pre, register: true }));
      const response = await api.localRegister({
        lcs: window.lcs,
        userName: values.userName,
        email: values.emailRegister,
        password: values.passwordRegister,
        phoneNumber: values.phoneNumber,
        affiliate: values.affiliate,
      });
      setLoading((pre) => ({ ...pre, register: false }));
      setTimeout(() => el.removeAttribute("disabled"), 1000 * 5);
      if (response.error)
        return messageRef.current.showError({
          message: (
            <div>
              <div> مشکل در انجام عملیات !</div>
              <div>{response.error}</div>
            </div>
          ),
        });
      const type = values.type === "phoneNumber" ? "پیامک" : "ایمیل";
      messageRef.current.showSuccess({
        message: `ثبت نام با موفقیت انجام و کد فعالسازی به ${type} فرستاده شد.`,
      });
      document.querySelector("#exampleModalToggle2 button").click();

      setTimeout(
        () =>
          navigate(`/${window.lang}/register/activate/ /${response.data._id}`),
        1000 * 1 * 1
      );
    },
    validationSchema: Yup.object({
      terms: Yup.boolean().oneOf([true], "خوندن و پذیرفتن قوانین یادتون نره!."),
      userName: Yup.string()
        .required("یک نام کاربری برای خودتون انتخاب کنید.")
        .min(3, "نام کاربری نباید کمتر از ۳ حرف باشه.")
        .max(20, "نام کاربری نباید بیشتر از ۲۰ حرف باشه."),
      // emailRegister: Yup.string()
      //   .email(" ایمیل را درست وارد کنید.")
      //   .required(" ایمیل خود را وارد کنید.")
      //   .trim()
      //   .lowercase(),
      passwordRegister: Yup.string()
        .required("یک کلمه عبور برای خودتون انتخاب کنید.")
        .matches(numericRegex, "در کلمه عبور حداقل یک عدد به کار ببرید")
        .matches(combinedRegex, "از حروف انگلیسی استفاده کنید")
        .min(8, "کلمه عبور حداقل باید ۸ حرف داشته باشه."),
      // .matches(lowercaseRegex, "حداقل یک حرف کوچک !")
      // .matches(uppercaseRegex, "حداقل یک حرف بزرگ")
      // .matches(specialcharRegex, "حداقل یک کاراکتر ویژه!")
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("passwordRegister")],
          "کلمه‌های عبور با هم همخوانی ندارند!"
        )
        .required("کلمه عبور را دوباره وارد کنید."),

      emailRegister: Yup.string()
        .trim()
        .lowercase()
        .when("type", (type, schema, value) => {
          return type !== "emailRegister"
            ? schema.notRequired()
            : schema
                .required("ایمیل را وارد کنید.")
                .email("ایمیل را به درستی وارد کنید.");
        }),

      phoneNumber: Yup.string()
        .when("type", (type, schema, value) => {
          return type !== "phoneNumber"
            ? schema.notRequired()
            : schema
                .required("شماره تلفن فراموش نشه!")
                .test(
                  "is-valid-phone",
                  "شماره تلفن را با + و کد کشور(مثال: 6543 987 514 1+) شروع کنید!",
                  (value) => {
                    return isValidPhoneNumber(value || "");
                  }
                );
        })
        .trim(),
    }),
  });
  // console.log("registerFormik.values", registerFormik.values);

  return (
    <>
      <ToastNote messageRef={messageRef} />
      <div
        className="modal fade"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <button
              id="CloseLoging"
              type="button"
              className="icon-btn bi-x  close-login"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div className="modal-body">
              <div className="row">
                <div className="col-md-7">
                  {/*<!-- Login Form -->*/}
                  <form
                    onSubmit={loginFormik.handleSubmit}
                    name="loginForm00"
                    autoComplete="true"
                  >
                    <div id="loginFormAddTxt" className="modal-body pb-0">
                      <fieldset className="form-group">
                        <div className="row d-flex justify-content-center">
                          <div className=" col-6 d-flex justify-content-center form-check">
                            <input
                              dir="ltr"
                              className="form-check-input"
                              placeholder="abc@metamarce.com "
                              type="radio"
                              name="loginFormikType"
                              id="gridRadios1"
                              value="email"
                              checked={loginFormik.values.type === "email"}
                              onChange={(e) =>
                                loginFormik.setValues((pre) => ({
                                  ...pre,
                                  type: e.target.value,
                                  phoneNumber: "",
                                }))
                              }
                            />
                            <label
                              className="form-check-label ps-2"
                              htmlFor="gridRadios1"
                            >
                              ایمیل
                            </label>
                          </div>
                          <div className=" col-6   d-flex justify-content-center form-check">
                            <input
                              dir="ltr"
                              className="form-check-input"
                              type="radio"
                              name="loginFormikType"
                              id="gridRadios3"
                              value="phoneNumber"
                              checked={
                                loginFormik.values.type === "phoneNumber"
                              }
                              onChange={(e) =>
                                loginFormik.setValues((pre) => ({
                                  ...pre,
                                  type: e.target.value,
                                  email: "",
                                }))
                              }
                            />
                            <label
                              className="form-check-label ps-2"
                              htmlFor="gridRadios3"
                            >
                              تلفن همراه
                            </label>
                          </div>
                        </div>
                      </fieldset>
                      {loginFormik.values.type === "email" ? (
                        <div>
                          <div className=" form-floating  mt-4 py-1">
                            <input
                              type="email"
                              autoComplete="true"
                              placeholder="abc@metamarce.com "
                              name="emailLogin02"
                              className="form-control py-0 box1 "
                              id="emailLogin02"
                              {...loginFormik.getFieldProps("email")}
                            />
                            <label htmlFor="emailLogin02" className="">
                              <i className="bi bi-envelope-fill"></i> ایمیل
                            </label>
                          </div>
                          <FormikErrRender formik={loginFormik} field="email" />
                        </div>
                      ) : (
                        <div>
                          <div className=" form-floating  mt-4 py-1">
                            <input
                              dir="ltr"
                              type="phone"
                              placeholder=" +15141234567"
                              name="emailLogin03"
                              className="form-control py-0 box1 "
                              id="emailLogin03"
                              // {...loginFormik.getFieldProps("phoneNumber")}
                              value={loginFormik.values.phoneNumber}
                              onChange={(e) =>
                                loginFormik.setValues((pre) => ({
                                  ...pre,
                                  phoneNumber: tools.convertToEnglish(
                                    e.target.value
                                  ),
                                }))
                              }
                            />
                            <label htmlFor="emailLogin03" className="">
                              <i className="bi bi-phone-fill"></i> تلفن همراه
                            </label>
                          </div>
                          <FormikErrRender
                            formik={loginFormik}
                            field="phoneNumber"
                          />
                        </div>
                      )}
                      <div className=" form-floating box1 input-group mt-4 pt-1 pb-0">
                        <input
                          dir="ltr"
                          type={showPassword.password ? "text" : "password"}
                          placeholder=" "
                          name="password"
                          className="form-control box6 border-0 py-0"
                          id="password"
                          {...loginFormik.getFieldProps("password")}
                        />
                        <span
                          className="input-group-append pt-3 d-flex align-items-center"
                          onMouseDown={(e) =>
                            setShowPassword((pre) => ({
                              ...pre,
                              password: !pre.password,
                            }))
                          }
                          onMouseUp={(e) =>
                            setTimeout(
                              () =>
                                setShowPassword((pre) => ({
                                  ...pre,
                                  password: false,
                                })),
                              6000
                            )
                          }
                        >
                          {showPassword.password ? (
                            <i className="bi bi-eye show-hide-icon"></i>
                          ) : (
                            <i className="bi bi-eye-slash show-hide-icon"></i>
                          )}
                          {/* {showPassword.password?<Visibility/>:<VisibilityOff/>} */}
                        </span>
                        <label htmlFor="password" className="">
                          <i className="bi bi-lock-fill"></i> کلمه عبور
                        </label>
                      </div>
                      <FormikErrRender formik={loginFormik} field="password" />
                      <div className="mb-3 pt-1 text-end ">
                        <Link
                          className="forget-pass"
                          data-bs-toggle="modal"
                          to="#exampleModalToggle3"
                        >
                          <i className="bi bi-exclamation-triangle-fill"></i>
                          فعالسازی / کلمه عبور را فراموش کردم
                        </Link>

                        {/* <button className="btn btn-primary" data-bs-target="#exampleModalToggle3" data-bs-toggle="modal">کلمه عبور را فراموش کردم</button> */}
                      </div>
                    </div>
                    <div className="text-center mb-3">
                      <button
                        id="loginBtn"
                        type="submit"
                        className="btn  btn-secondary mx-auto w-50 login-btn "
                        // onClick={loginHandel}
                      >
                        {loading.login ? (
                          <CircularProgress color="inherit" size="20px" />
                        ) : (
                          "ورود"
                        )}
                      </button>
                    </div>
                    <div className="text-center my-4">
                      <span className="line-log">
                        --------------------------
                      </span>
                      <span className="or-log"> یا </span>
                      <span className="line-log">
                        --------------------------
                      </span>
                    </div>

                    <div className="container-fluid pt-0">
                      {/*<!-- Section: Social media -->*/}
                      <div className="mt-0 mr2">
                        <ul className="d-flex justify-content-center p-0 m-0">
                          <li className="px-2">
                            <img
                              src="/img/socialMedia/dropbox.svg"
                              className="img-login"
                              alt="faceBookHandle"
                              onClick={faceBookHandle}
                              loading="lazy"
                            />
                          </li>
                          <li className="px-2">
                            <img
                              src="/img/socialMedia/google-2.svg"
                              className="img-login"
                              alt="googleHandle"
                              onClick={googleHandle}
                              loading="lazy"
                            />
                          </li>

                          <li className="px-2">
                            <img
                              src="/img/socialMedia/twitter.png"
                              className="img-login"
                              alt="twitterHandle"
                              onClick={twitterHandle}
                              loading="lazy"
                            />
                          </li>
                          {/* Keep This Github */}
                          {/* <li className="px-2">
                            <img
                              src="/img/socialMedia/github-2.svg"
                              //  src="/img/icons/github-2.svg"

                              // src="data:image/png;base64,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"
                              className="img-login"
                              alt="githubHandle"
                              onClick={githubHandle}
                            />
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-md-5 align-items-center">
                  <img
                    className="image-ad-respo "
                    src="/img/Images/login-animate.svg"
                    alt="login"
                    style={{ verticalAlign: "bottom" }}
                    loading="lazy"
                  />
                  <div className="modal-footer d-flex justify-content-center text-center">
                    {/* <p className="text-center">هنوز عضو نشدم!</p> */}
                    <button
                      className="btn primary-btn checkout-btn cart-footer"
                      data-bs-target="#exampleModalToggle2"
                      data-bs-toggle="modal"
                    >
                      هنوز عضو نشدم | ثبت‌نام
                    </button>
                    {/* <a
                      className="link small-gray-font"
                      href={`/${window.lang}/prompt/privacy`}
                      target="_blank"
                    >
                      سیاست حفظ حریم شخصی
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <button
              type="button"
              className="icon-btn bi-x  close-login"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-7">
                  {/*<!-- Register Form -->*/}

                  <form
                    onSubmit={registerFormik.handleSubmit}
                    name="registerForm01"
                    autoComplete="true"
                  >
                    <div className="modal-body pb-0">
                      <fieldset className="form-group">
                        <div className="row d-flex justify-content-center">
                          <div className=" col-6  d-flex justify-content-center form-check">
                            <input
                              dir="ltr"
                              className="form-check-input"
                              type="radio"
                              name="registerType"
                              id="gridRadios11"
                              value="emailRegister"
                              autoComplete="off"
                              checked={
                                registerFormik.values.type === "emailRegister"
                              }
                              onChange={(e) =>
                                registerFormik.setValues((pre) => ({
                                  ...pre,
                                  type: e.target.value,
                                  phoneNumber: "",
                                }))
                              }

                              // {...registerFormik.getFieldProps('type')}
                            />
                            <label
                              className="form-check-label ps-2"
                              htmlFor="gridRadios11"
                            >
                              ایمیل
                            </label>
                          </div>
                          <div className="col-6 d-flex justify-content-center form-check">
                            <input
                              dir="ltr"
                              className="form-check-input"
                              type="radio"
                              name="registerType"
                              id="gridRadios2"
                              value="phoneNumber"
                              checked={
                                registerFormik.values.type === "phoneNumber"
                              }
                              onChange={(e) =>
                                registerFormik.setValues((pre) => ({
                                  ...pre,
                                  type: e.target.value,
                                  emailRegister: "",
                                }))
                              }
                              // {...registerFormik.getFieldProps('type')}
                            />
                            <label
                              className="form-check-label ps-2"
                              htmlFor="gridRadios2"
                            >
                              تلفن همراه
                            </label>
                          </div>
                        </div>
                      </fieldset>
                      <div className=" form-floating  mt-2 py-1">
                        <input
                          type="name"
                          autoComplete="off"
                          placeholder=" "
                          name="name"
                          className={`form-control box1 py-0 ${addErrClass({
                            formik: registerFormik,
                            field: "name",
                          })} `}
                          id="name"
                          {...registerFormik.getFieldProps("userName")}
                        />
                        <label htmlFor="name" className="">
                          <i className="bi bi-person-fill"></i> نام کاربری
                        </label>
                      </div>
                      <FormikErrRender
                        formik={registerFormik}
                        field="userName"
                      />

                      {registerFormik.values.type === "emailRegister" ? (
                        <div>
                          <div className="form-floating  mt-2 py-1">
                            <input
                              dir="ltr"
                              type="email"
                              autoComplete="true"
                              placeholder="abc@metamarce.com"
                              name="emailRegister"
                              className={`form-control box1 py-0 ${addErrClass({
                                formik: registerFormik,
                                field: "emailRegister",
                              })} `}
                              id="emailRegister"
                              {...registerFormik.getFieldProps("emailRegister")}
                            />
                            <label htmlFor="emailRegister" className="">
                              <i className="bi bi-envelope-fill"></i> ایمیل
                            </label>
                          </div>
                          <FormikErrRender
                            formik={registerFormik}
                            field="emailRegister"
                          />
                        </div>
                      ) : (
                        <div>
                          <div className="form-floating  mt-2 py-1">
                            <input
                              dir="ltr"
                              type="phone"
                              name="phoneNumber"
                              placeholder="+15141234567"
                              className={`form-control box1 py-0 ${addErrClass({
                                formik: registerFormik,
                                field: "phoneNumber",
                              })} `}
                              id="phoneNumber"
                              // {...registerFormik.getFieldProps("phoneNumber")}
                              value={registerFormik.values.phoneNumber}
                              onChange={(e) =>
                                registerFormik.setValues((pre) => ({
                                  ...pre,
                                  phoneNumber: tools.convertToEnglish(
                                    e.target.value
                                  ),
                                }))
                              }
                            />
                            <label htmlFor="phoneNumber" className="">
                              <i className="bi bi-phone-fill"></i>تلفن همراه
                            </label>
                          </div>
                          <FormikErrRender
                            formik={registerFormik}
                            field="phoneNumber"
                          />
                        </div>
                      )}

                      <div
                        className={`form-floating input-group box1 mt-2 py-1 ${addErrClass(
                          { formik: registerFormik, field: "passwordRegister" }
                        )} `}
                      >
                        <input
                          dir="ltr"
                          type={showPassword.password ? "text" : "password"}
                          placeholder=" "
                          name="password"
                          className={`form-control box6 border-0 py-0 `}
                          id="passwordRegister"
                          {...registerFormik.getFieldProps("passwordRegister")}
                        />
                        <label htmlFor="passwordRegister" className="">
                          <i className="bi bi-lock-fill"></i> کلمه عبور
                        </label>
                        <span
                          className="input-group-append pt-3 d-flex align-items-center"
                          onMouseDown={(e) =>
                            setShowPassword((pre) => ({
                              ...pre,
                              password: !pre.password,
                            }))
                          }
                          onMouseUp={(e) =>
                            setTimeout(
                              () =>
                                setShowPassword((pre) => ({
                                  ...pre,
                                  password: false,
                                })),
                              6000
                            )
                          }
                        >
                          {showPassword.password ? (
                            <i className="bi bi-eye show-hide-icon"></i>
                          ) : (
                            <i className="bi bi-eye-slash show-hide-icon"></i>
                          )}
                          {/* {showPassword.password?<Visibility/>:<VisibilityOff/>} */}
                        </span>
                      </div>
                      <FormikErrRender
                        formik={registerFormik}
                        field="passwordRegister"
                      />

                      <div
                        className={` form-floating  input-group box1 mt-2 py-1 ${addErrClass(
                          { formik: registerFormik, field: "confirmPassword" }
                        )} `}
                      >
                        <input
                          dir="ltr"
                          type={showPassword.rPass ? "text" : "password"}
                          placeholder=" "
                          name="passwordRegister"
                          className={`form-control box6 border-0 py-0`}
                          id="confirmPassword"
                          {...registerFormik.getFieldProps("confirmPassword")}
                        />
                        <label htmlFor="confirmPassword" className="">
                          <i className="bi bi-lock-fill"></i> تکرار کلمه عبور
                        </label>
                        <span
                          className="input-group-append pt-3 d-flex align-items-center"
                          onMouseDown={(e) =>
                            setShowPassword((pre) => ({
                              ...pre,
                              rPass: !pre.rPass,
                            }))
                          }
                          onMouseUp={(e) =>
                            setTimeout(
                              () =>
                                setShowPassword((pre) => ({
                                  ...pre,
                                  rPass: false,
                                })),
                              6000
                            )
                          }
                        >
                          {showPassword.rPass ? (
                            <i className="bi bi-eye show-hide-icon"></i>
                          ) : (
                            <i className="bi bi-eye-slash show-hide-icon"></i>
                          )}
                          {/* {showPassword.rPass?<Visibility/>:<VisibilityOff/>} */}
                        </span>
                      </div>
                      <FormikErrRender
                        formik={registerFormik}
                        field="confirmPassword"
                      />

                      <div className="modal-footer p-0 ">
                        <button
                          id="registerBtn"
                          type="submit"
                          className="btn  btn-secondary mx-auto w-50 login-btn mt-4"
                        >
                          {loading.register ? (
                            <CircularProgress color="inherit" size="20px" />
                          ) : (
                            "ثبت نام"
                          )}
                        </button>
                      </div>
                    </div>

                    <div className="text-center my-4">
                      <span className="line-log">
                        ---------------------------
                      </span>
                      <span className="or-log"> یا</span>
                      <span className="line-log">
                        ---------------------------
                      </span>
                    </div>

                    <div className="container-fluid pt-0">
                      {/*<!-- Section: Social media -->*/}
                      <div className="mt-0 mr2">
                        <ul className="d-flex justify-content-center p-0 m-0">
                          <li className="px-2">
                            <a href="#">
                              <img
                                src="/img/socialMedia/dropbox.svg"
                                className="img-login"
                                alt="faceBookHandle"
                                onClick={faceBookHandle}
                                loading="lazy"
                              />
                            </a>
                          </li>
                          <li className="px-2">
                            <img
                              src="/img/socialMedia/google-2.svg"
                              className="img-login"
                              alt="googleHandle"
                              onClick={googleHandle}
                              loading="lazy"
                            />
                          </li>

                          <li className="px-2">
                            <img
                              src="/img/socialMedia/twitter.png"
                              className="img-login"
                              alt="twitterHandle"
                              onClick={twitterHandle}
                              loading="lazy"
                            />
                          </li>
                          {/* <li className="px-2">
                            <img
                              src="/img/socialMedia/github-2.svg"
                              //  src="/img/icons/github-2.svg"

                              // src="data:image/png;base64,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"
                              className="img-login"
                              alt="githubHandle"
                              onClick={githubHandle}
                              loading="lazy"
                            />
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-md-5 align-self-end   ">
                  <img
                    className="image-ad-respo "
                    src="/img/illustration/mobile-login-animate.svg"
                    alt="mobile-login"
                    style={{ verticalAlign: "bottom" }}
                    loading="lazy"
                  />

                  <div className="modal-footer mb-5 d-flex flex-column justify-content-centertext-center">
                    {/* <p className="text-center py-2"> عضو هستم! </p> */}
                    <button
                      className="btn primary-btn checkout-btn cart-footer"
                      data-bs-target="#exampleModalToggle"
                      data-bs-toggle="modal"
                    >
                      عضو هستم | ورود
                    </button>
                    <div
                      className={`${addErrClass({
                        formik: registerFormik,
                        field: "terms",
                      })}`}
                    >
                      <input
                        className="form-check-input my-3"
                        type="checkBox"
                        id="privacyBtn"
                        defaultChecked={registerFormik.values.terms}
                        {...registerFormik.getFieldProps("terms")}
                      />
                      <label
                        className={`small-gray-font required my-3 `}
                        htmlFor="privacyBtn"
                      >
                        قوانین را می پذیرم.
                      </label>
                      <a
                        className="link small-gray-font fw-bold fst-italic"
                        href={`/${window.lang}/prompt/privacy`}
                        target="_blank"
                      >
                        (مشاهده قوانین)
                      </a>
                    </div>
                    <FormikErrRender formik={registerFormik} field="terms" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModalToggle3"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel3"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <button
              type="button"
              className="icon-btn bi-x  close-login"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-7">
                  {/*<!-- password recovery Form -->*/}
                  <form
                    onSubmit={passRecoverFormik.handleSubmit}
                    name="passRecoverForm03"
                    autoComplete="true"
                  >
                    <div className="modal-body">
                      <fieldset className="form-group">
                        <div className="row d-flex justify-content-center">
                          <div className=" col-6 d-flex justify-content-center form-check">
                            <input
                              dir="ltr"
                              className="form-check-input"
                              type="radio"
                              name="passRecoverFormikTypeEmail"
                              id="passRecoverInputEmail"
                              value="email"
                              checked={
                                passRecoverFormik.values.type === "email"
                              }
                              onChange={(e) =>
                                passRecoverFormik.setValues((pre) => ({
                                  ...pre,
                                  type: e.target.value,
                                  phoneNumber: "",
                                }))
                              }
                            />
                            <label
                              className="form-check-label ps-2"
                              htmlFor="passRecoverInputEmail"
                            >
                              ایمیل
                            </label>
                          </div>
                          <div className=" col-6   d-flex justify-content-center form-check">
                            <input
                              dir="ltr"
                              className="form-check-input"
                              type="radio"
                              name="passRecoverFormikTypeEmail"
                              id="passRecoverInputPhone"
                              value="phoneNumber"
                              checked={
                                passRecoverFormik.values.type === "phoneNumber"
                              }
                              onChange={(e) =>
                                passRecoverFormik.setValues((pre) => ({
                                  ...pre,
                                  type: e.target.value,
                                  email: "",
                                }))
                              }
                            />
                            <label
                              className="form-check-label ps-2"
                              htmlFor="passRecoverInputPhone"
                            >
                              تلفن همراه
                            </label>
                          </div>
                        </div>
                      </fieldset>

                      {passRecoverFormik.values.type === "email" ? (
                        <div>
                          <div className=" form-floating  mt-4 py-1">
                            <input
                              dir="ltr"
                              type="email"
                              autoComplete="true"
                              placeholder="abc@metamarce.com "
                              name="email"
                              className="form-control box1 py-0 "
                              id="emailLogin06"
                              {...passRecoverFormik.getFieldProps("email")}
                            />
                            <label htmlFor="emailLogin06" className="">
                              <i className="bi bi-envelope-fill"></i> ایمیل
                              {/* <Tooltip1
                              // icon={<Help sx={{ fontSize: 15, padding: 0,bgcolor:"disabled"}}/>}
                              message="فرستادن ایمیل ممکن است تا دو دقیقه زمان ببرد."
                              position="left"
                            /> */}
                            </label>
                          </div>
                          <FormikErrRender
                            formik={passRecoverFormik}
                            field="email"
                          />
                        </div>
                      ) : (
                        <div>
                          <div className=" form-floating  mt-4 py-1">
                            <input
                              dir="ltr"
                              type="phone"
                              placeholder="+15141234567 "
                              name="phone"
                              className="form-control box1 py-0 "
                              id="emailLogin01"
                              {...passRecoverFormik.getFieldProps(
                                "phoneNumber"
                              )}
                            />
                            <label htmlFor="emailLogin01" className="">
                              <i className="bi bi-phone-fill"></i> تلفن همراه
                            </label>
                          </div>
                          <FormikErrRender
                            formik={passRecoverFormik}
                            field="phoneNumber"
                          />
                        </div>
                      )}
                    </div>
                    <div className="text-center ">
                      <button
                        type="submit"
                        className="btn  btn-secondary mx-auto w-md-50 w-75 login-btn"
                        id="passRecoverBtn"
                      >
                        {loading.passRec ? (
                          <CircularProgress color="inherit" size="20px" />
                        ) : (
                          <div>بازیابی کلمه عبور</div>
                        )}
                      </button>
                    </div>

                    <div className="modal-footer mt-3 d-flex justify-content-center">
                      <Link
                        className="btn primary-btn checkout-btn cart-footer"
                        to="#exampleModalToggle"
                        data-bs-toggle="modal"
                      >
                        بازگشت به صفحه پیش
                      </Link>
                    </div>
                  </form>
                </div>
                <div className="col-md-5 align-self-end d-sm-none d-md-block">
                  <img
                    className="image-ad-respo"
                    src="/img/Images/forgot-password-animate.svg"
                    alt="forgot-password"
                    style={{ verticalAlign: "bottom" }}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Link
        id="loginTrigger"
        className="btn login-trigger-user shadow-none "
        data-bs-toggle="modal"
        to="#exampleModalToggle"
        role="button"
      >
        <i className="bi bi-person-circle"></i> ورود | ثبت‌نام
      </Link>
    </>
  );
}
